import React from "react";

export function Accordion({ items }) {
  return (
    <div className="mkt-acc" data-testid="mkt-accordion">
      {items.map((it, i) => (
        <details key={i} data-testid={`mkt-acc-item-${i}`}>
          <summary>{it.q}</summary>
          {it.a.split("\n\n").map((p, j) => (
            <p key={j}>{p}</p>
          ))}
        </details>
      ))}
    </div>
  );
}
